import axiosInstance, { microServices } from 'network/apis/index'
import { getAuthToken } from 'utils/common-services/cookie.service'
import { LOADER_HANDLER_TYPES, METHOD_TYPES } from 'utils/constants/index'

const getAuthHeaders = () => {
  const token = getAuthToken()
  return token ? { authorization: `Bearer ${token}` } : {}
}

export const getAllCurrencyService = () => {
  return axiosInstance(METHOD_TYPES.get, 'system/get-all-currency', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table
  })
}
export const getGameSettingService = () => {
  return axiosInstance(METHOD_TYPES.get, 'system/get-game-settings', {}, {
    headers: getAuthHeaders(),
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table
  })
}

export const getGameDetailsService = () => {
  return axiosInstance(METHOD_TYPES.get, 'system/get-game-settings', {}, {
    headers: getAuthHeaders(),
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table
  })
}
